import ZJApp from '../../../../app'

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
    service: 'UniformAuthService',
    controller: 'Product'
}
const methods = [
    'AddItem',
    'UpdateItem',
    'DelItem',
    'DelItemList',
    'GetItemById',
    'GetItemByProductId',
    'GetItemByProductCode',
    'FindByConditions',
    'GetPageContentByConditions',
    'GetProducts',
    'GetProductsPaging'
]

const factory = (Fun)=>{
    utils.extend(Fun.prototype, info)
    methods.forEach(path => {
        Fun.prototype[path] = function(data) {
            return this.post(path, data)
        }
    })
}

const ProductApi = ZJApi.defineNewApi('ProductApi', factory)

export default ProductApi